// // project import
// import Routes from 'routes';
// import ThemeCustomization from 'themes';
// import ScrollTop from 'components/ScrollTop';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { decodeToken } from 'utils/functions/jwt-token';
// import { useEffect, useState, useRef } from 'react';
// import calculateExpirationTime from 'utils/functions/calculate-expiration-time';
// import { useDispatch, useSelector } from 'react-redux';
// import { logout, refreshSession } from 'store/reducers/userSlice';
// import { logoutUser } from 'store/reducers/actions';
// import { useLocation, useNavigate } from 'react-router';
// import { getJwtToken } from 'utils/functions/session-storage';
// import { PASS_KEY } from 'variables';
// import Notification from 'components/@ui/notification/Notification';
// import FeedbackOverlay from 'components/@ui/feedback/FeedbackOverlay';
// import { useChunkErrorHandler } from 'hooks/useChunkErrorHandler';

// // ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
// // console.log(process.env.NODE_ENV);

// const App = () => {
//   // useDirection();
//   console.log('rendered App');
//   useChunkErrorHandler();
//   // const features = useSelector((state) => state.user?.permissions);
//   // const btype = useSelector((state) => state.user?.user?.exp);
//   const [mouseMoved, setMouseMoved] = useState(false);
//   // const { auth } = useAuth();

//   const tokenData = decodeToken();
//   const exp = tokenData?.exp;
//   const exth = tokenData?.exth;
//   const { pathname } = useLocation();
//   const pathComponents = pathname.split('/');
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const currentTime = Math.floor(Date.now() / 1000);
//   const { expTimeLeft, refreshTimeLeft } = calculateExpirationTime(currentTime, exp);
//   const token = getJwtToken();
//   const tokenRef = useRef(true);

//   // const headers = {
//   //   'Content-Type': 'application/json',
//   //   'Pass-Key': PASS_KEY,
//   //   Authorization: token
//   // };

//   // useEffect(() => {
//   //   if (!userRef.current) {
//   //     dispatch(getPermissions({ headers, btype: exth, pmtr_acct: 'v3d4103ecB' }));
//   //   }

//   //   return () => {
//   //     userRef.current = true;
//   //   };
//   // }, []);

//   function handleMouseMove() {
//     if (!mouseMoved) {
//       setMouseMoved(true);
//       clearTimeout(timeoutId); // Cancel the timeout if the mouse is moved
//     }
//   }

//   let timeoutId;
//   useEffect(() => {
//     if (refreshTimeLeft) {
//       // Set timeout to run after 30 seconds
//       const componentTimeout = setTimeout(() => {
//         // Log the message after 3 seconds
//         // timeoutId = setTimeout(() => {
//         document.addEventListener('mousemove', handleMouseMove);
//         // }, refreshTimeLeft + 2000);
//       }, refreshTimeLeft);

//       // Event listener for mouse movement

//       if (mouseMoved && tokenRef.current === true) {
//         //  refreshToken();
//         dispatch(refreshSession());
//         document.removeEventListener('mousemove', handleMouseMove);
//       }

//       // Cleanup function
//       return () => {
//         clearTimeout(componentTimeout);
//         clearTimeout(timeoutId);
//         setMouseMoved(false);
//         tokenRef.current = false;
//         document.removeEventListener('mousemove', handleMouseMove);
//       };
//     }
//   }, [mouseMoved, refreshTimeLeft]);

//   useEffect(() => {
//     // if (!token && expTimeLeft === 'EXPIRED') {
//     //   dispatch(logout());
//     //   dispatch(logoutUser());
//     //   redirect('/login');
//     // }
//     if (!token && !expTimeLeft && pathname !== '/' && pathComponents[1] !== 'public') {
//       navigate('/login', { replace: true });
//       return;
//     }

//     const logoutTimer = setTimeout(() => {
//       if (pathname !== '/' && pathComponents[1] !== 'public') {
//         navigate('/login', { replace: true });
//       }
//       dispatch(logout());
//       dispatch(logoutUser());
//     }, expTimeLeft);

//     return () => clearTimeout(logoutTimer);
//   }, [expTimeLeft, token]);

//   return (
//     <ThemeCustomization>
//       <LocalizationProvider dateAdapter={AdapterDayjs}>
//         <ScrollTop>
//           <FeedbackOverlay />
//           <Notification />
//           <Routes />
//         </ScrollTop>
//       </LocalizationProvider>
//     </ThemeCustomization>
//   );
// };

// export default App;

// App.js
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Notification from 'components/@ui/notification/Notification';
import FeedbackOverlay from 'components/@ui/feedback/FeedbackOverlay';
import { useChunkErrorHandler } from 'hooks/useChunkErrorHandler';
import { memo } from 'react';
import { useAuthManager } from 'hooks/useAuthManager';

// ==============================|| APP - MAIN COMPONENT ||============================== //

const App = memo(() => {
  // console.log('rendered App');

  // Custom hooks handle all the complex logic
  useChunkErrorHandler();
  useAuthManager();

  return (
    <ThemeCustomization>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ScrollTop>
          <FeedbackOverlay />
          <Notification />
          <Routes />
        </ScrollTop>
      </LocalizationProvider>
    </ThemeCustomization>
  );
});

App.displayName = 'App';

export default App;
